import {WaveContainerProps} from "./props";
import Lottie, {useLottie} from "lottie-react";
import WaveBlue from "../../../../assets/lottie/common/wave-blue.json";
import WaveOrange from "../../../../assets/lottie/common/wave-orange.json";
import WaveWhite from "../../../../assets/lottie/common/wave-white.json";
import {StyledWaveContainer} from "./style";
import classNames from "classnames";
import styled from "styled-components";

const StyledWaveBackground = styled.div`
  background-color: white !important;
`;

export const WaveContainer = (props: WaveContainerProps) => {
  const {children, isBottom, isTop, containerStyle, topColor = 'white', bottomColor = 'white'} = props

  let currentColor = {
    'white': '#fff',
    'blue': WaveBlue,
    'orange': WaveOrange
  }

  // let bgColor = {
  //   'white': '#fff',
  //   'blue': '#E7FAFF',
  //   'orange': '#FCF8F1'
  // }


  const topOptions = (position: string) => ({
    animationData: currentColor[topColor],
    loop: true,
    className: classNames('wave', {
      [position]: 'position',
      [topColor]: 'color'
    })
  })

  const bottomOptions = (position: string) => ({
    animationData: currentColor[bottomColor],
    loop: true,
    className: classNames('wave', {
      [position]: 'position',
      [bottomColor]: 'color'
    })
  })
  const {View: TopView} = useLottie(topOptions('top'));
  const {View: BottomView} = useLottie(bottomOptions('bottom'));


  return (
    <StyledWaveContainer>
      {isTop && <StyledWaveBackground>{TopView}</StyledWaveBackground>}

      <div style={{
        zIndex: 1,
        position: 'relative',
        ...containerStyle
      }}>
        {children}
      </div>

      {isBottom && <StyledWaveBackground>{BottomView}</StyledWaveBackground>}
    </StyledWaveContainer>
  )
}